module.exports = __webpack_public_path__ + "static/img/building.8315ddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/building.png
// module id = guhP
// module chunks = 29